import { PropsWithChildren } from 'react';

import { Flex } from '@/components/utils';

export const NavigationItemsList = ({ children }: PropsWithChildren) => {
  return (
    <Flex
      className="nav-items-container"
      column
      sx={{
        width: '100%',
        alignItems: 'center',
        gap: '8px',
        '.nav-item': {
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#21005D',
          '&:hover': {
            backgroundColor: 'rgba(33, 0, 93, 0.10)',
          },
        },
        '.navbar-link': {
          zIndex: 9999,
          '&:first-child': {
            '&.active': {
              background: 'transparent',
              '&:hover': {
                background: 'transparent',
              },
            },
          },
        },
        '.active': {
          borderRadius: '10px',
          background: '#21005D',
          '* ': {
            color: 'white',
          },
          '&:hover': {
            background: '#21005D',
          },
        },
      }}
    >
      {children}
    </Flex>
  );
};
